import * as React from "react";

import { InstantAnswerContext } from "../../../types";

export const LazyCallbackQueueModal = React.lazy<
  React.ComponentType<InstantAnswerContext>
>(() =>
  import(
    /* webpackChunkName: "callback-queue-modal-view" */ "./CallbackQueueModal"
  ).then((module) => {
    return {
      default: module.CallbackQueueModal,
    };
  })
);
